import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../nodeInstance";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";
import { useDispatch, useSelector } from "react-redux";
import DropDownList from "../../../../ReusableComponents/DropDownList/DropDownList";
import { AiOutlineClose } from "react-icons/ai";
import UploadFilePopUp_New from "../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function ListDateAbsher({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const [Popup, setPopUp] = useState(false);
  const [editingIndex, setEditingIndex] = React.useState();
  const [email, setEmail] = React.useState();
  const [mobileValue, setMobile] = React.useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [status, setStatus] = useState("");
  const dispatch = useDispatch();

  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  const statusValue = (event) => {
    setStatus(event.target.value);
    console.log("value ", event.target.value);
  };

  // list.border_number

  const handleEmail = (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);
    console.log(newEmail);
  };
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  //edit text Field
  const handleEdit = (index, initialValue) => {
    setEditingIndex(index);
  };

  const handleMobile = (event) => {
    setMobile(event.target.value);
    console.log(event.target.value);
  };

  // Check if the entered email is valid

  const update = async (type) => {
    console.log("......type......", type);
    if (type.absher_status === "PENDING" || type.absher_status === "Pending") {
      dispatch(
        setAppError({
          msg: "Absher status should be done inorder to proceed",
          // color: "success",
        })
      );
      return;
    }
    try {
      console.log(type);
      const res = await nodeinstance.post("/absher/updateAbsher/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setEditingIndex(-1);
        apiCall();
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(`/absher/downloadAbsherExcel`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Absher`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const [searchData, setSearchData] = useState("");
  const [searchKey, setSearchKey] = useState("");

  const onClearResponse = () => {
    setSearchKey("");
    setSearchData("");
  };

  const handleSearchData = (e) => {
    setSearchKey(e.target.value);
  };

  const onIconClick = async () => {
    try {
      const response = await nodeinstance.get(
        `/absher/getDatabySerach/${searchKey}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSearchData(response.data.data);
      }
    } catch (error) {
      console.log("error to  be seeb in console", error);
    }
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(searchData ? searchData : list?.data || []);

  const apiCall = () => {
    updateData("123654");
  };

  console.log("mobileValue to be seen in the console", mobileValue, status);

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex justify-between space-x-2">
          <div className="flex flex-wrap  gap-2 w-full items-center flex-row-reverse">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => setPopUp(true)}
            >
              <p>Upload List</p>
              {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
            </button>
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => downloadFile()}
              disabled={downloadLoading || list?.isLoading}
            >
              <p>Download</p>
              {downloadLoading && <CgSpinner className="animate-spin" />}
            </button>
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => {
                onClearResponse();
              }}
            >
              <p>Clear filter</p>
            </button>
            <div style={styles.container}>
              <input
                type="text"
                placeholder="Enter text here"
                style={styles.input}
                value={searchKey}
                onChange={(e) => {
                  handleSearchData(e);
                }}
              />
              <span
                style={styles.tickIcon}
                onClick={() => {
                  onIconClick();
                }}
              >
                ✔️
              </span>
            </div>
          </div>
        </div>
        {/* <p className="text-sm w-full text-right font-medium mb-1">
        {`Slide / scroll to right >`}
      </p> */}
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[1900px]">
              <div className="grid grid-cols-table-abser gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-abser gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.project_coordinator || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      {editingIndex === index ? (
                        <DropDownList
                          value={list.absher_status}
                          setValue={statusValue}
                          presetValues={[
                            // { value: "PENDING" },
                            { value: "DONE" },
                          ]}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.absher_status || "-"}
                          />
                        </p>
                      )}
                    </p>

                    <p>
                      {editingIndex === index ? (
                        <input
                          defaultValue={list.mobile_number}
                          type="number"
                          name={list.mobile_number}
                          className={`input input-sm h-10 max-w-xs  w-full
                      input-bordered focus:outline-none uppercase`}
                          id={list.mobile_number}
                          required="er"
                          pattern="[0-9]*"
                          value={mobileValue}
                          placeholder="05"
                          maxLength={10}
                          onChange={(e) => {
                            let input = e.target.value;
                            if (input.length <= 10) {
                              handleMobile(e);
                            }
                          }}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.mobile_number || "-"}
                          />
                        </p>
                      )}
                    </p>

                    <p>
                      {editingIndex === index ? (
                        <input
                          type="text"
                          name={list.email}
                          // className={!isValidEmail ? "invalid" : ""}
                          className={`input input-sm h-10 max-w-xs  w-full
                      input-bordered focus:outline-none uppercase`}
                          id={list.email}
                          defaultValue={list.email}
                          required="er"
                          onChange={(e) => {
                            handleEmail(e);
                          }}
                          // onChange={}
                        />
                      ) : (
                        <p className="overflow-x-hidden">
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.email || "-"}
                          />
                        </p>
                      )}
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.absher_status || "Pending"}
                      />
                    </p>
                    <div>
                      <button
                        className={
                          editingIndex === index
                            ? "px-2 rounded-md  bg-green-500 text-white text-xs p-2 w-20"
                            : "px-2 rounded-md  bg-red text-white text-xs p-2 w-20"
                        }
                        onClick={() => {
                          console.log(list.border_number);
                          if (editingIndex === index) {
                            if (mobileValue.length === 10) {
                              update({
                                employeeId: list.employee_id,
                                absher_status: status,
                                mobile_number: mobileValue,
                                email: email,
                              });
                            } else {
                              dispatch(
                                setAppError({
                                  msg: "Please enter vaild mobile number",
                                })
                              );
                              return;
                            }
                          } else {
                            handleEdit(index, list.boderNumber);
                            setMobile(list.mobile_number);
                            setEmail(list.email);
                            setStatus(list.absher_status || "PENDING");
                          }
                        }}
                      >
                        {editingIndex === index ? "Save" : "Update"}
                      </button>

                      {editingIndex === index ? (
                        <button
                          className="ml-4"
                          onClick={() => {
                            setEditingIndex(-1);
                          }}
                        >
                          <AiOutlineClose />
                        </button>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <hr className="border-[1.5px] border-slate-100 w-full col-span-full" />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Absher"}
          url={"/absher/updateAbsherFromExcel"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
    </>
  );
}
